import axios from "axios";
import { Storage } from "./storage-services";
const url = process.env.VITE_PUBLIC_BASE_URL;

const api = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json",
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = Storage.getItem("TreasuraAdminUserToken");
    const businessId = Storage.getItem("businessId");
    const env = Storage.getItem("env");

    config.headers.Authorization = `Bearer ${token}`;
    config.headers["x-app-version"] = 37;
    config.headers["x-business-id"] = `${businessId}`;
    config.headers["x-env"] = env;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

window.onload = () => {
  const reloading = sessionStorage.getItem("reloading");
  if (reloading) {
    sessionStorage.removeItem("reloading");
  }
};

const handleLogout = () => {
  localStorage.clear();

  sessionStorage.setItem("reloading", "true");
  window.location.reload();
};

api.interceptors.response.use(
  function (response) {
    return response;
  },
  async (error) => {
    const { message, status } = error.response?.data ?? {};
    if (
      status === 401 ||
      message === "Invalid or expired session" ||
      message === "invalid business id supplied"
    ) {
      handleLogout();
    }
    return Promise.reject(error);
  },
);

export default api;
